import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { kpiBulkCopy, kpi, kpitarget, benchmarkkpi } from './../../../models/slakpi';
import { UtilityService } from './../../../services/utility.service';
import { BMApiService } from './../../../services/bm.service';
import { UserService } from './../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'

import { Router } from '@angular/router';
import { year } from './../../../models/slakpi';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,
  OnEventArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';
@Component({
  selector: 'app-kpi-target',
  templateUrl: './bench-mark-kpi-target.component.html',
  styleUrls: ['./bench-mark-kpi-target.component.css']
})
export class BenchmarkKPITargetComponent implements OnInit {

  public data: any;
  public fulldata: any;
  public kpiData: object[];
  public kpiTarget: kpitarget[];
  public editSettings: Object;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;
  public pageAction: string = 'add';
  public submitClicked: boolean = false;
  public permission: number = 1;
  public selected_schedule: number = 1;
  modalRef: BsModalRef;
  @ViewChild('editSettingsTemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('KPIBulkUpdateDialog', { static: false }) KPIBulkUpdateDialog: TemplateRef<any>;
  columnDefinitions: Column[];
  public defaultyear: number = 0;
  public selected_kpiUno: number = 0;
  public kpiTargetForm: FormGroup;
  public yearsArray: FormArray;
  user: any = {};
  login_UserID: string; // number

  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;

  isAdmin: boolean = false;
  gridOptions: GridOption;
  dataset: any;
  //for the buld process
  public position_chart: object = { X: 570, Y: 150 };

  public CurrentyearText: string = '';
  public quaterData: any;
  public destinationData: any;
  public Bulk_Type: any;
  public Bulk_Source: any;
  public Bulk_Target: any;
  public frequency_data: any;
  public isProgress: boolean = false
  public yearUno?: number;
  public isDataEntryError: boolean = false;
  public txtDataEntryError: string = '';

  public loading: boolean = true;
  public yearUno_start: number;
  public yearUno_end: number;
  public yearData: any;
  angularGrid: AngularGridInstance;
  headerTitle: string;

  
  public isBMChambion: boolean = false;
  public isBMTeam: boolean = false;
    searchText: string;
    dataSearch: any;
  public isBMChampion: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
  constructor(public restApi: BMApiService, public utilityService: UtilityService, private toaster: ToasterService, private modalService: BsModalService, private router: Router, private userService: UserService, private spinner: SpinnerVisibilityService, private formBuilder: FormBuilder) {


    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission
  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Benchmarking KPI Target");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.defaultyear = Number(this.user.currentYear);
    this.yearUno = this.user.currentYear;
    this.yearUno_start = this.yearUno;
    this.yearUno_end = this.yearUno;
    this.CurrentyearText = this.defaultyear.toString();

    this.loadQuater();
    this.getFrequency();
    this.loadYear();
    setTimeout(() => {
      this.loadKPI();
    }, 500);

  }
  //To Validate Current User - Page Level Permission
  CheckUserPermission() {

    let userPermissionData = this.userService.getUserRights("KPI Target");
    if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;


      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }
  showBulkProcessDialog() {

    this.CurrentyearText = this.user.currentYear.toString();
    this.frequency_data = [];
    this.getFrequency();
    this.quaterData = [];
    this.Bulk_Type = '';
    this.Bulk_Source = '';
    this.Bulk_Target = '';
    this.destinationData = [];
   
    this.modalRef = this.modalService.show(
      this.KPIBulkUpdateDialog,
      Object.assign({}, {
        class: 'gray modal-md',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }
  getFrequency() {
    this.frequency_data = [
      { value: 2, displayText: 'Semi-annually' }
    ];
  }
  loadQuater() {


    this.quaterData = [
      { value: 1, displayText: 'Q1' },
      { value: 2, displayText: 'Q2' },
      { value: 3, displayText: 'Q3' },
      { value: 4, displayText: 'Q4' }

    ];
  }
  loadHalfQuater() {
    this.quaterData = [
      { value: 1, displayText: 'First Half' },
      { value: 2, displayText: 'Second Half' }

    ];
  }
  loadYearDrp() {
    this.quaterData = [
      { value: 1, displayText: 'From Year' }


    ];
  }
  loadDestination() {
    

    if (this.Bulk_Source == 'Q1' || this.Bulk_Source == 'Q2' || this.Bulk_Source == 'Q3' || this.Bulk_Source == 'Q4') {
      this.destinationData = [
        { value: 1, displayText: 'Q1' },
        { value: 2, displayText: 'Q2' },
        { value: 3, displayText: 'Q3' },
        { value: 4, displayText: 'Q4' },
        { value: 5, displayText: 'Yearly' }
      ];
    }
    else {
      if (this.Bulk_Type == 'Annually') {
        this.destinationData = [
          { value: 1, displayText: 'To Year' }

        ];
      } else {
        this.destinationData = [
          { value: 1, displayText: 'First Half' },
          { value: 2, displayText: 'Second Half' }
        ];
      }
    }
  }
  onchangeFrequency(e) {
    
    this.Bulk_Type = (e.length > 0) ? e[0].text : 0;
    this.Bulk_Source = null;
    this.Bulk_Target = null;
    if (this.Bulk_Type == 'Quarterly') {
      this.loadQuater();
    }
    else if (this.Bulk_Type == 'Annually') {
      this.loadYearDrp();
    }
    else {
      this.loadHalfQuater();
    }
  }

  onchangeSource(e) {
    this.Bulk_Source = (e.length > 0) ? e[0].text : 0;
    this.destinationData = [];
    this.Bulk_Target = '';
    this.loadDestination();
  }

  onchangeTarget(e) {
    this.Bulk_Target = (e.length > 0) ? e[0].text : 0;
  }


  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiNameEn && a.kpiNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.unitEn && a.unitEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.divisionName && a.divisionName.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.dataSearch;
  }

  setColnDefn() {
    let temp = this;

    if (this.isBMChampion || this.isBMVisitor) {
      this.columnDefinitions = [
        {
          id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, type: FieldType.string, filterable: true, width: 300,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
            model: Filters.multipleSelect,

          }
        },
        {
          id: 'unitEn', name: 'Unit', field: 'unitEn', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'unitEn', 'unitEn'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'divisionName', name: 'Business Account', field: 'divisionName', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'divisionName', 'divisionName'),
            model: Filters.multipleSelect,
          }
        }
      ]
    }
    else {

      this.columnDefinitions = [
        {
          id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, type: FieldType.string, filterable: true, width: 300,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
            model: Filters.multipleSelect,

          }
        },
        {
          id: 'unitEn', name: 'Unit', field: 'unitEn', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'unitEn', 'unitEn'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'divisionName', name: 'Business Account', field: 'divisionName', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'divisionName', 'divisionName'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'action', name: 'Action', field: 'action', width: 50, cssClass: 'blue',
          type: FieldType.string, formatter: (row, cell, val, columnDef, data) => { return '<span style="cursor:pointer"><i class="fa fa-pencil-square-o fa-lg"></i></span>'; },
          onCellClick: (e: Event, args: OnEventArgs) => {
            this.pageAction = 'edit';
            let objdata: any = args.dataContext;
            objdata = this.fulldata.filter((items: any) => items.kpiUno == objdata.id)[0];
            
            this.data = objdata;
            if (objdata.slaRuleUno != 1 && objdata.slaRuleUno != 2) {
              this.submitClicked = false;

              this.toaster.show('warning', 'Warning', 'KPI Target option is not available to edit');
              return;
            }
            if (this.permission == 1) {
              this.submitClicked = false;

              this.createFormGroup(objdata);
              //this.headerTitle = 'Details of ' + objdata.kpiNameEn + " | " + objdata.scheduleName;
              this.headerTitle = 'Details of ' + objdata.kpiNameEn;
              this.selected_schedule = objdata.scheduleUno;
              this.selected_kpiUno = objdata.kpiUno == null || objdata.kpiUno == '' ? objdata.strKPIUno.replace('k_', '') : objdata.kpiUno;
              this.addItem(objdata.kpiUno == null || objdata.kpiUno == '' ? objdata.strKPIUno.replace('k_', '') : objdata.kpiUno, objdata.frequencyUno);

              this.modalRef = this.modalService.show(
                this.addtemplate,
                Object.assign({}, {
                  class: 'gray modal-lg',
                  backdrop: true,
                  keyboard: true,
                  focus: true,
                  show: false,
                  ignoreBackdropClick: true,
                  animated: true
                })
              );
            }
          }
        }
        //,{
        //  id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        //  excludeFromExport: true,
        //  formatter: this.actionFormatter,
        //  cellMenu: {
        //    hideCloseButton: false,
        //    commandTitleKey: 'COMMANDS',
        //    commandItems: [
        //      {
        //        command: 'edit-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
        //        itemVisibilityOverride: (args: MenuCallbackArgs) => {
        //          let data = args.dataContext;

        //          if (this.isBMChampion || this.isBMVisitor)
        //            return false;
        //          else return true;
        //        },
        //        iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
        //        action: (e, args) => {
        //          this.pageAction = 'edit';
        //          let objdata: any = args.dataContext;
        //          objdata = this.fulldata.filter((items: any) => items.kpiUno == objdata.id)[0];
        //          
        //          this.data = objdata;
        //          if (objdata.slaRuleUno != 1 && objdata.slaRuleUno != 2) {
        //            this.submitClicked = false;

        //            this.toaster.show('warning', 'Warning', 'KPI Target option is not available to edit');
        //            return;
        //          }
        //          if (this.permission == 1) {
        //            this.submitClicked = false;

        //            this.createFormGroup(objdata);
        //            this.headerTitle = 'Details of ' + objdata.kpiNameCode + " | " + objdata.scheduleName;
        //            this.selected_schedule = objdata.scheduleUno;
        //            this.selected_kpiUno = objdata.kpiUno == null || objdata.kpiUno == '' ? objdata.strKPIUno.replace('k_', '') : objdata.kpiUno;
        //            this.addItem(objdata.kpiUno == null || objdata.kpiUno == '' ? objdata.strKPIUno.replace('k_', '') : objdata.kpiUno, objdata.frequencyUno);

        //            this.modalRef = this.modalService.show(
        //              this.addtemplate,
        //              Object.assign({}, {
        //                class: 'gray modal-lg',
        //                backdrop: true,
        //                keyboard: true,
        //                focus: true,
        //                show: false,
        //                ignoreBackdropClick: true,
        //                animated: true
        //              })
        //            );
        //          }
        //        },
        //        // only show command to 'Delete Row' when the task is not completed

        //      },



        //    ],
        //  }
        //}




      ]
    }
    


  }

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };


  saveTarget() {
    this.submitClicked = true;
    if (this.kpiTargetForm.valid) {
      this.AddEditKPITarget(this.kpiTargetForm.value);
    }
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  onBulkCopySubmit() {
    if (this.Bulk_Type == '' || this.Bulk_Source == '' || this.Bulk_Target == '') {
      this.isDataEntryError = true;
      this.txtDataEntryError = "Please enter all required information."
      return;
    }
    else if (this.yearUno_start > this.yearUno_end) {
      this.isDataEntryError = true;
      this.txtDataEntryError = "The [Year From] should be less than or equal to [Year To]."
      return;
    }
    else {
      this.isDataEntryError = false;
      this.txtDataEntryError = "";
    }
    Swal.fire({
      title: 'Copy KPI Target',
      text: 'Please Confirm to Start the Copy KPI Target',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {

        this.spinner.show();
        let inpValue = new kpiBulkCopy();
        inpValue.yearFrom = this.yearUno_start;
        inpValue.yearTo = this.yearUno_end;
        inpValue.source = this.Bulk_Source;
        inpValue.target = this.Bulk_Target;
        inpValue.frequency = this.Bulk_Type;
        inpValue.tenantUno = 1;
        inpValue.userUno = this.login_UserID;
        this.isProgress = true;
        

        this.restApi.bulkBenchmarkKPITargetProcess(inpValue)
          .subscribe(data => {
            
            this.spinner.hide();
            this.modalRef.hide();
            this.isProgress = false;


            //Swal.fire({
            //  type: 'success',
            //  title: 'KPI Targets successfully copied from ' + this.yearUno_start + '-' + this.Bulk_Source + ' to ' + this.yearUno_end + '-' + this.Bulk_Target + '.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})

            this.toaster.show('success', 'Success', 'KPI Targets successfully copied from ' + this.yearUno_start + '-' + this.Bulk_Source + ' to ' + this.yearUno_end + '-' + this.Bulk_Target + '.');
          },
            (error) => {
              //Called when error
              this.spinner.hide();
              this.isProgress = false;
              this.modalRef.hide();
              //Swal.fire({
              //  type: 'success',
              //  title: 'KPI Targets successfully copied from ' + this.yearUno_start + '-' + this.Bulk_Source + ' to ' + this.yearUno_end + '-' + this.Bulk_Target + '.',
              //  showConfirmButton: false,
              //  timer: 1500
              //})
              this.toaster.show('success', 'Success', 'KPI Targets successfully copied from ' + this.yearUno_start + '-' + this.Bulk_Source + ' to ' + this.yearUno_end + '-' + this.Bulk_Target + '.');
            }
          ).add(() => {
            //Called when operation is complete (both success and error)
            this.spinner.hide();
          });

        return;
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    })


  }
  isRange(element, index, array) {
    return (element.slaRuleName == 'Range');
  }


  // Get kpi list
  loadKPI() {
    this.spinner.show();
    let inpValue = new benchmarkkpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    //inpValue.userUno = 2;
    inpValue.frequencyUno =  0;
    inpValue.slaRuleUno =  0;
    inpValue.businessDivisionUno = 0;
    inpValue.reportingDivisionUno =  0;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getBenchMarkKPIs(inpValue)
      .subscribe(data => {
        
        this.spinner.show();
        let dataOutput: any = data;
        this.fulldata = dataOutput;
        this.kpiData = uniqBy(data, 'kpiUno');
      
        const mockDataset = [];
        for (let i = 0; i < this.fulldata.length; i++) {
          mockDataset[i] = {
            id: this.fulldata[i].kpiUno,
            kpiCode: this.fulldata[i].kpiCode,
            kpiNameEn: this.fulldata[i].kpiNameEn,
            unitEn: this.fulldata[i].unitEn,
            scheduleName: this.fulldata[i].scheduleName,
            slaRuleName: this.fulldata[i].slaRuleName,
            kpiRule: this.fulldata[i].kpiRule,
            divisionName: this.fulldata[i].divisionName,
            formula: this.fulldata[i].formula
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.kpiData = this.fulldata;
        this.loading = false;
        this.spinner.hide()

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.show();
      });
  }


  createFormGroup(data1: any) {

    this.kpiTargetForm = this.formBuilder.group({
      kpiUno: '',
      yearsArray: this.formBuilder.array([])
    });
  }
  createyearItem(objkpitarget: kpitarget): FormGroup {
    
    return this.formBuilder.group({
      kpiUno: objkpitarget.kpiUno,
      kpiYear: objkpitarget.kpiYear,
      kpiYear_Text: objkpitarget.kpiYear_Text,
      frequency: objkpitarget.frequency,
      kpitarget1: objkpitarget.kpitarget1,
      kpitarget2: objkpitarget.kpitarget2,
      kpitarget3: objkpitarget.kpitarget3,
      kpitarget4: objkpitarget.kpitarget4,
      kpitarget5: objkpitarget.kpitarget5,
      kpitarget6: objkpitarget.kpitarget6,
      kpitarget7: objkpitarget.kpitarget7,
      kpitarget8: objkpitarget.kpitarget8,
      kpitarget9: objkpitarget.kpitarget9,
      kpitarget10: objkpitarget.kpitarget10,
      kpitarget11: objkpitarget.kpitarget11,
      kpitarget12: objkpitarget.kpitarget12,
      kpitarget13: objkpitarget.kpitarget13
    });
  }
  addItem(kpiuno, Frequency): void {
    this.yearsArray = this.kpiTargetForm.get('yearsArray') as FormArray;
    while (this.yearsArray.length) {
      this.yearsArray.removeAt(0);
    }
    this.spinner.show();
    let inpValue = new kpitarget();
    inpValue.languageUno = 1033;
    inpValue.kpiUno = kpiuno;
    inpValue.kpiYear = this.defaultyear;
    inpValue.frequency = Frequency;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    
    this.restApi.getBenchmarkTargets(inpValue)
      .subscribe(kpidata => {
        let objkpidata: any = kpidata;
        if (objkpidata != null && objkpidata.length > 0)
          for (var i = 0; i < 11; i++) {
            
            this.yearsArray.push(this.createyearItem(kpidata[i]));
          }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });


  }

  AddEditKPITarget(data1: any) {
    if (this.kpiTargetForm == null || this.kpiTargetForm.invalid) {
      //Swal.fire('Error', 'Something went wrong', 'error')
      this.toaster.show('error', 'Error', 'Something went wrong');
      return false;
    }
    let arrayYear = data1.yearsArray;
    for (let i = 0; i < arrayYear.length-1; i++) {
      if (arrayYear[i].kpitarget3 == null) {
        this.toaster.show('error', 'Error', 'Please enter ' + arrayYear[i].kpiYear +" target value");
        return false; 
      }
    }


    
    let objKPITarget = new kpitarget();

    objKPITarget.listkpiTarget = data1.yearsArray;
    objKPITarget.userUno = this.login_UserID;
    objKPITarget.kpiYear = this.defaultyear;
    objKPITarget.kpiUno = this.selected_kpiUno;
    objKPITarget.condition = 0;//(this.pageAction == "add") ? 0 : 1;
    objKPITarget.tenantUno = this.tenantUno;
    

    this.restApi.addBenchmarkTarget(objKPITarget)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Target Saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})

          this.toaster.show('success', 'Success', 'Benchmark KPI target saved.');
          this.loadKPI();
        }
        this.modalRef.hide();

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

    return true;

  }

  //isNumberKey(txt, evt,item) {
  //  
    
  //  var textValue = (<HTMLInputElement>document.getElementById("txtActual_" + item));
  //  //RemoveSpecial Charecter

  //  (<HTMLInputElement>document.getElementById("txtActual_" + item)).value == '';
  //  textValue.value = (textValue.value.length > 0) ? textValue.value.replace(/[^0-9.]/g, "") : '';

  //  //Remove morethen one dot value
  //  if (textValue.value.replace(/[^.]/g, "").length > 1) {
  //    textValue.value = textValue.value.substring(0, textValue.value.length - 1);
  //  }

  //  return false;
  //}


  // Get Year / Quater
  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getYearMasterAll(inpValue)
      .subscribe(data => {
        
        this.yearData = data;
        //this.inpyeardata.addItem({ text: 'All', value: '0' }, 0);
        setTimeout(() => {
          this.yearUno_end = Number(this.yearUno);// Number(this.yearUno);
          this.yearUno_start = Number(this.yearUno);// Number(this.yearUno);

        }, 10);
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

}
